/**
 * Avatar — a person's initials in a disc, in every app (ADR-0088 D2). Always
 * round: one shape for a person, wherever they appear.
 *
 * - `tone`: `accent` (solid yellow with ink initials: signed-in account menus),
 *   `soft` (a quieter accent tint) or
 *   `neutral` (quiet grey: a person shown, not the one signed in).
 * - `size` in px, 34 by default. Leave it out to size the avatar from the
 *   app's own CSS (a responsive heading avatar); the initials' type stays
 *   with the page.
 * - `render` sets the element: a menu trigger renders the avatar as its
 *   button. Purely visual otherwise; give it `aria-hidden` where the name is
 *   already on screen.
 */
import { useRender } from '@base-ui/react/use-render';
import { cva } from 'class-variance-authority';
import { cn } from './cn.js';
const avatarVariants = cva('inline-flex size-[34px] shrink-0 items-center justify-center rounded-full font-bold', {
    variants: {
        tone: {
            accent: 'bg-accent text-on-accent',
            soft: 'bg-accent-soft text-text-primary',
            neutral: 'border border-border-default bg-surface-card-inset text-text-secondary',
        },
    },
    defaultVariants: { tone: 'accent' },
});
export function Avatar({ tone, size, render, className, style, ref, ...props }) {
    return useRender({
        render,
        ref,
        defaultTagName: 'span',
        props: {
            ...props,
            'data-slot': 'avatar',
            className: cn(avatarVariants({ tone }), className),
            style: size === undefined ? style : { width: size, height: size, ...style },
        },
    });
}
//# sourceMappingURL=avatar.js.map